import {IconArrowMerge} from '@tabler/icons-react'
import {ActionIcon, Badge} from '@mantine/core'

type Props = {
  onClick?: () => void
}

export const MergedBadge = ({onClick}: Props) => {
  return (
    <ActionIcon variant={'subtle'} radius={'xl'} onClick={onClick} title={`Show merged recommendations`}>
      <Badge size={'lg'} circle pl={3} pt={5} variant={'light'} style={{pointerEvents: 'none'}}>
        <IconArrowMerge size={18} stroke={1} />
      </Badge>
    </ActionIcon>
  )
}
